import { render, staticRenderFns } from "./CreateUnionModal.vue?vue&type=template&id=e05c7ae6&scoped=true&"
import script from "./CreateUnionModal.vue?vue&type=script&lang=js&"
export * from "./CreateUnionModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateUnionModal.vue?vue&type=style&index=0&id=e05c7ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e05c7ae6",
  null
  
)

export default component.exports